import {useFloatingHeader} from '@logistics-frontend/utils/hooks'
import clsx from 'clsx'
import React from 'react'

import * as classes from './FloatingBox.classes'

type Props = React.PropsWithChildren<{
  className?: string
  sentinelRef: React.RefObject<HTMLElement>
}>

export function FloatingBox({children, className, sentinelRef}: Props): React.ReactElement<Props> {
  const isFloatingSubmitButton = useFloatingHeader(sentinelRef)

  return <div className={clsx(className, {[classes.root]: isFloatingSubmitButton})}>{children}</div>
}
